/// <amd-module name="Build/Common/Commands/newfolder/Command" />
import * as React from "react";

import { Folder } from "Build/Client/Contracts/Build";
import { IBuildRestClient } from "Build/Client/RestClient/Build";
import { DisallowedCharacters, CharacterLimits} from "Build/Common/Commands/Constants";
import { INewFolderProps, INewFolderState } from "Build/Common/Commands/newfolder/Command.types";
import { handleError } from "Build/Common/Library/ErrorHandler";

import { Dialog } from "VSSUI/Dialog";
import { FormItem } from "VSSUI/FormItem";
import { TitleSize } from "VSSUI/Header";
import { TextFieldWithMessage } from "VSSUI/TextField";

import { format } from "VSS/Core/Util/String";
import { VssComponent } from "VSS/Platform/Layout";

import * as Resources from "Build/Common/Commands/Resources";

class NewFolder extends VssComponent<INewFolderProps, INewFolderState> {
    public static componentType = "ciNewFolderComponent";

    constructor(props: INewFolderProps) {
        super(props);

        this.state = {
            name: "",
            description: "",
            nameErrorMessage: ""
        };
    }

    public render() {
        const fullPath: string | undefined = this.props.parentPath === "\\" ? undefined : this.props.parentPath + "\\";

        return (
            <Dialog
                defaultActiveElement=".folderNameField"
                calloutContentClassName="ci-dialog"
                footerButtonProps={[
                    {
                        onClick: this._onDismiss,
                        text: Resources.Cancel
                    },
                    {
                        disabled: this.state.nameErrorMessage.length > 0 || this.state.name.trim().length === 0,
                        onClick: this._onCommit,
                        primary: true,
                        text: Resources.Create
                    }
                ]}
                onDismiss={this._onDismiss}
                titleProps={{ text: Resources.NewFolderDialogTitle, size: TitleSize.Large }}
            >
                <FormItem message={this.state.nameErrorMessage} error={this.state.nameErrorMessage.length > 0}>
                    <TextFieldWithMessage 
                        textFieldProps={{ 
                            ariaLabel: Resources.FolderNameLabel,
                            inputClassName: "folderNameField", 
                            value: this.state.name, 
                            onChange: this._onNameChanged, 
                            placeholder: Resources.FolderNamePlaceholder }}  
                        message={fullPath} 
                        messageClassName="pipelines-new-folder-dialog-name" />
                </FormItem>
            </Dialog>
        );
    }

    private _onCommit = () => {
        this.props.onClose();

        let client = this.props.pageContext.getRestClient<IBuildRestClient>("IBuildRestClient");

        let newFolder: Folder = {
            path: this.props.parentPath + "\\" + this.state.name.trim()
        } as Folder;

        client.createFolder(newFolder, this.props.projectId, newFolder.path).then((newFolder: Folder) => {
            if (this.props.onFolderCreated) {
                this.props.onFolderCreated(newFolder);
            }
        }, handleError);
    };

    private _onDismiss = () => {
        this.props.onClose();
    };

    private _checkInvalidCharacters = (value: string, invalidCharacters: string) => {
        for (let i = 0; i < invalidCharacters.length; i++) {
            if (value.indexOf(invalidCharacters[i]) !== -1) {
                return true;
            }
        }
        return false;
    };

    private _onNameChanged = (event: React.ChangeEvent<HTMLInputElement>, newValue: string) => {
        let errorMessage = "";
        if (newValue.trim().length === 0) {
            errorMessage = "";
        } else {
            const invalidCharacters = DisallowedCharacters.DisallowedFolderNameCharacters;
            const fullPath = this.props.parentPath + "\\" + this.state.name.trim();
            if(this._checkInvalidCharacters(newValue, invalidCharacters)) {
                errorMessage = format(Resources.UnallowedNameCharactersErrorMessage, invalidCharacters);
            }
            else if(fullPath.length > CharacterLimits.MaxPathNameLength) {
                errorMessage = format(Resources.UnallowedFolderPathLength, CharacterLimits.MaxPathNameLength);
            }
        }
        this.setState({
            name: newValue,
            nameErrorMessage: errorMessage
        });
    };
}

VssComponent.register(NewFolder.componentType, NewFolder);
